import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { left_arrow, right_arrow } from "../../assets/imgs";
import Select from "react-select";
import SelectBox from "../SelectBox";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  useLazyOwnersListGetQuery,
  useLazyPropertyReceptionListQuery,
  useLazyReceptionListGetQuery,
  usePropertiesAddMutation,
  usePropertyReceptionListMutation,
  useReceptionListMutation,
} from "../../screens/redux/api/api";
import { toast } from "react-toastify";
import CustomSearchSelect from "../Searchbox/CustomSearch";
import { Placeholder } from "react-bootstrap";

const AddProperty = ({
  setValueType,
  valueType,
  setTabs,
  setProperty_id,
  setOwner_id,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [next, setNext] = useState(false);

  const [receptionist, setReceptionist] = useState(2);

  const [userName, setUserName] = useState([]);
  const [userID, setUserID] = useState([]);
  const [validation, setValidation] = useState("");

  const [userNames, setUserNames] = useState([]);
  const [userIDs, setUserIDs] = useState([]);
  const [validations, setValidations] = useState("");

  const [propertyName, setPropertyName] = useState("");
  const [receptionList, setReceptionList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [ownerId, setOwnerId] = useState("");

  //RTK
  const [receptionListApi] = useLazyReceptionListGetQuery();
  const [recepListApi] = useLazyPropertyReceptionListQuery();
  const [ownerListApi] = useLazyOwnersListGetQuery();
  const [propertyAddApi] = usePropertiesAddMutation();

  const getreceptionList = () => {
    receptionListApi()
      .unwrap()
      .then((res) => {
        console.log(res);
        setReceptionList(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getOwnerList = () => {
    ownerListApi()
      .unwrap()
      .then((res) => {
        console.log(res, "owners");
        setOwnerList(res?.owners);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getRecpList = (id) => {
    recepListApi(id)
      .unwrap()
      .then((res) => {
        console.log(res);
        setReceptionList(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    let owner = userIDs[0];
    console.log("owner", owner);
    if (owner) {
      getRecpList(owner);
    }
    setOwnerId(owner);
    setOwner_id(owner);
  }, [userIDs]);

  useEffect(() => {
    getOwnerList();
    setUserName([]);
    console.log("usetrName", userName);
  }, []);

  const addProperty = () => {
    if (!propertyName) {
      toast.error("Enter Property");
      return;
    }
    if (!ownerId) {
      toast.error("Enter Owner");
      return;
    }

    if (userName.length == 0 && userID.length == 0 && receptionist === 1) {
      toast.error("Select the Receptionist");
      return;
    }
    if (!userID) {
      toast.error("Select the Owner");
      return;
    } else {
      setLoader(true);

      const receptionistIds = userID.map((id) => Number(id));

      const ownerId = userIDs.length > 0 ? Number(userIDs[0]) : null;

      const payload = {
        name: propertyName,
        property_type: valueType,
        receptionist_id: receptionistIds,
        owner_id: ownerId,
      };

      console.log("Payload:", payload);

      let formdata = new FormData();
      formdata.append("name", propertyName);
      formdata.append("edit", Number(0));
      formdata.append("property_type", valueType == 1 ? 2 : 1);

      receptionistIds.map((id, index) => {
        formdata.append(`receptionist_id[${index}]`, id);
      });

      formdata.append("owner_id", ownerId);
      formdata.append("created_by", "admin");

      propertyAddApi(formdata)
        .unwrap()
        .then((res) => {
          console.log(res);
          if (res?.status == "success") {
            console.log("response", res);
            toast.success(res?.message);
            setProperty_id(res?.data?.id);
            setPropertyName("");
            setOwnerList([]);
            setReceptionList([]);
            setTabs(2);
            setLoader(false);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  const removeOwner = (ind) => {
    let temp = [...userNames];
    let temps = [...userIDs];
    temp.splice(ind, 1);
    temps.splice(ind, 1);
    setUserNames(temp);
    setUserIDs(temps);
  };

  console.log("userNames", userNames);

  const removeAmenities = (ind) => {
    let temp = [...userName];
    let temps = [...userID];
    temp.splice(ind, 1);
    temps.splice(ind, 1);
    setUserName(temp);
    setUserID(temps);
  };

  return (
    <div className=" mt-2">
      <div className="d-flex ac-js">
        <div
          className="d-flex ac-js pointer gap-2"
          onClick={() => navigate(-1)}
        >
          <img src={left_arrow} className="leftArrow mb-3" />
          <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
            Back
          </p>
        </div>
      </div>

      <div className="">
        <div className="d-flex gap-5 mb-4 align-items-center">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Property Name *
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Property Name"
              value={propertyName}
              onChange={(e) => setPropertyName(e.target.value)}
            />
          </div>
          <div className="col-md-5 mt-3">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Owner Name *
            </h4>
            {console.log(userIDs, "ownerId")}
            <div className="mb-3">
              <SelectBox
                array_list={ownerList} // array
                value_text={userNames} // array
                setvalue_text={setUserNames} // array
                setvalue_id={setUserIDs} // array
                value_id={userIDs} // array
                placeholder_text={"Select.."} // string
                setValidation={setValidations} // string
                isMulti={false} // boolean
                isTextArea={false} // boolean
                ownerData={true}
              />
            </div>

            <div className="d-flex ac-jb flex-wrap gap-3 ">
              {userNames?.map((item, ind) => {
                let data = item?.address.split(",").map((i) => i.trim());
                let address = data?.slice(-3).join(", ");
                return (
                  <div key={ind} className="position-relative w-100">
                    <input
                      type="text"
                      className="input-pop ps-2 w-100"
                      value={`${item.name} - ${item.owner_id} - ${address}`}
                      readOnly
                    />
                    <div onClick={() => removeOwner(ind)}>
                      <CancelIcon
                        className="red pointer"
                        style={{
                          position: "absolute",
                          top: "-7px",
                          right: "-7px",
                          width: "15px",
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Receptionist *
            </h4>
            <div className="d-flex ac-js flex-wrap gap-3 mb-3">
              <button
                className={
                  receptionist == 1 ? "cust-btn recep-yes" : "cust-btn recep-no"
                }
                onClick={() => {
                  setReceptionist(1);
                  setShow(true);
                }}
              >
                Yes
              </button>
              <button
                className={
                  receptionist == 2 ? "cust-btn recep-yes" : "cust-btn recep-no"
                }
                onClick={() => {
                  setReceptionist(2);
                  setShow(false);
                  setUserName([]);
                }}
              >
                No
              </button>
            </div>
            {show && (
              <div className="mb-3">
                <div>
                  <SelectBox
                    array_list={receptionList} // array
                    value_text={userName} // array
                    setvalue_text={setUserName} // array
                    setvalue_id={setUserID} // array
                    value_id={userID} // array
                    placeholder_text={"Select..."} // string
                    setValidation={setValidation} // string
                    isMulti={true} // boolean
                    isTextArea={false} // boolean
                  />
                </div>

                <div className="d-flex ac-jb flex-wrap gap-3 mt-2">
                  {console.log("userName", userName)}
                  {userName?.map((item, ind) => {
                    return (
                      <div key={ind} className="position-relative w-40">
                        <input
                          type="text"
                          className="input-pop ps-2 w-100"
                          value={item}
                        />
                        <div onClick={() => removeAmenities(ind)}>
                          <CancelIcon
                            className="red  pointer"
                            style={{
                              position: "absolute",
                              top: "-7px",
                              right: "-7px",
                              width: "15px",
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Type *
            </h4>
            {/* <Select
              className="input-pop"
              options={selectType}
              value={valueType}
              onChange={setValueType}
              placeholder="Select..."
            /> */}

            <div className="d-flex ac-jb">
              <p
                className={`${
                  valueType == 1 ? "yellow-box" : "yellow-box_new"
                } pointerView`}
                onClick={() => setValueType(1)}
              >
                Individual Villa
              </p>
              <p
                className={`${
                  valueType == 2 ? "yellow-box" : "yellow-box_new"
                } pointerView`}
                onClick={() => setValueType(2)}
              >
                Hotel Rooms
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex ac-je">
          <div className="d-flex ac-js pointer gap-2">
            <p
              className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary"
              onClick={() => addProperty()}
            >
              {loader ? "loading" : "Next"}
            </p>
            <img
              src={right_arrow}
              className="leftArrow mb-3"
              onClick={() => addProperty()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProperty;
